import React from "react";
import { Stack, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const PositionDataTable = ({
  firstName,
  lastName,
  jobTitle,
  jobReqId,
  applicationId,
  configuration,
}) => {
  const { t } = useTranslation();
  if ((!firstName, !lastName, !jobReqId, !jobTitle)) return;
  return (
    <Stack
      spacing={2}
      sx={{
        backgroundColor: "#f5f5f5",
        padding: 3,
        mt: 1,
        justifyContent: "center",
      }}
      direction={{ xs: "column", md: "row" }}
    >
      {configuration?.JobApplicationDetails.map((field) => {
        if (field === "fullName") {
          return (
            <Box key="candidate-name">
              <b>{t("applicationDetails.candidateName")}</b>: {firstName}{" "}
              {lastName}
            </Box>
          );
        }
        if (field === "jobReqId") {
          return (
            <Box key="requisition-id">
              <b>{t("applicationDetails.requisitionId")}</b>: {jobReqId}
            </Box>
          );
        }
        if (field === "externalTitle") {
          return (
            <Box key="position-title">
              <b>{t("applicationDetails.positionTitle")}</b>: {jobTitle}
            </Box>
          );
        }
        if (field === "applicationId") {
          return (
            <Box key="application-id">
              <b>{t("applicationDetails.applicationId")}</b>: {applicationId}
            </Box>
          );
        }
        return null;
      })}
    </Stack>
  );
};

export default PositionDataTable;
